import { HttpModel } from '@/Shared/domain'
import type { TpvModel, TpvsRepository } from '@/Store/domain'
import { TpvForm } from '@/Store/ui/hooks'

interface ITpvs {
  getTpvsData: (merchantTargetId: number) => Promise<HttpModel<TpvModel[]>>
  addNewTpv: (data: TpvForm) => Promise<HttpModel<boolean>>
}

export const TpvsContract = (tpvsRepository: TpvsRepository): ITpvs => ({
  getTpvsData: async (merchantTargetId: number): Promise<HttpModel<TpvModel[]>> =>
    await tpvsRepository.GetTpvsData(merchantTargetId),
  addNewTpv: async (data: TpvForm): Promise<HttpModel<boolean>> =>
    await tpvsRepository.AddNewTpv(data),
})
